import React from "react";

import Link from "shared/components/Link";

import UpgradeIcon from "../icons/Upgrade.svg";
import {
	selectedOptionOnNavBarEvent,
	selectedFirstPartyPromoEvent,
} from "../analytics";

import "./UpgradeLink.scss";

const UpgradeLink = () => {
	return (
		<Link
			to="/upgrade?cf=desktopnavbar"
			className="upgrade-link"
			onClick={() => {
				selectedOptionOnNavBarEvent("Alist");
				selectedFirstPartyPromoEvent("alist");
			}}
		>
			<UpgradeIcon />
			<span className="upgrade-link-text">Get A-List</span>
		</Link>
	);
};

export default UpgradeLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/UpgradeLink/UpgradeLink.jsx